import cookie from "./cookie";

export function isLogin() {
    var ppu = cookie.get("PPU");
    return ppu != null && ppu != '';
}

export function goCommonPage(url,title="",pageCarrier="common"){
    //代码从是在app基础上改 所以还按照app定义的形式
    if(window._SOURCE === "ganji"){
        window.WBAPP.action.pagetrans('core',{
            pagetype:pageCarrier,
            title,
            url,
        });
    }else{
        window.location.href = url;
    }
}

export function setlog(actionType,opts={}){
//console.log('埋点',actionType)
//opts 为Object对象数据
if(JSON.stringify(opts) !== "{}"){
    for(var i in opts){
    actionType=`${actionType}&${i}=${opts[i]}`;
    }
}
console.log('埋点',actionType)
window.clickLog&&clickLog("from="+actionType);
}

export function query(name) {
const loc = window.location
const search = loc.search
    var reQuery, matches, cache
    if (!search) {
        // 返回null,表示不存在搜索字段
        // 而不返回''，是为了当存在搜索字段，但没有值的情况混淆
        return null
    }
    reQuery = new RegExp(name + '=([^=&?]*)', 'g')
    cache = []
    while ((matches = reQuery.exec(search))) {
        cache.push(decodeURIComponent(matches[1]))
    }
    if (cache.length) {
        return cache.length === 1 ? cache[0] : cache
    }
    return null
}